import { InjectionToken } from '@angular/core';
import { FullscriptService } from '../services/fullscript/fullscript.service';

export const FULLSCRIPT_SERVICE = new InjectionToken<FullscriptService>(
  'FULLSCRIPT_SERVICE'
);
